<template>
  <div class="pool-search-wrap">
    <div class="pool-search-box">
      <i class="fa fa-search search-icon" />
      <input
        v-model.trim="localKeyword"
        class="pool-search-input"
        :placeholder="
          $l('form_placeholder_pendingGoodsKeyword') || 'SKU / 品名...'
        "
        @keyup.enter="query"
      />
      <button v-if="localKeyword" class="search-clear" @click="clearKeyword">
        <i class="el-icon-circle-close" />
      </button>
    </div>

    <group-toggle-button
      v-if="hasGroups"
      :expanded="allGroupsExpanded"
      @toggle="$emit('toggle-all-groups')"
    />

    <BatchAssignButton
      :checkedCount="checkedCount"
      @batch-assign="$emit('batch-assign')"
    />

    <GroupPopover
      :groupFields="groupFields"
      :groupableFields="groupableFields"
      @change-group-fields="$emit('change-group-fields', $event)"
    />
  </div>
</template>

<script>
import BatchAssignButton from './batch-assign-button.vue'
import GroupPopover from './group-popover.vue'
import GroupToggleButton from './group-toggle-button.vue'

export default {
  components: { BatchAssignButton, GroupPopover, GroupToggleButton },
  props: {
    keyword: { type: String, default: '' },
    groupFields: { type: Array, default: () => [] },
    groupableFields: { type: Array, default: () => [] },
    allGroupsExpanded: { type: Boolean, default: false },
    hasGroups: { type: Boolean, default: false },
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      localKeyword: this.keyword,
    }
  },
  watch: {
    keyword(val) {
      this.localKeyword = val
    },
  },
  methods: {
    query() {
      this.$emit('query', this.localKeyword.trim())
    },
    clearKeyword() {
      this.localKeyword = ''
      this.query()
    },
  },
}
</script>

<style scoped>
.pool-search-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pool-search-box {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 10px;
  color: #94a3b8;
  pointer-events: none;
  font-size: 13px;
}

.pool-search-input {
  width: 100%;
  height: 32px;
  padding: 0 28px 0 32px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #1e293b;
  font-size: 12px;
  outline: none;
  transition: all 0.2s;
  font-family: inherit;
}

.pool-search-input::placeholder {
  color: #94a3b8;
}

.pool-search-input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

.search-clear {
  position: absolute;
  right: 6px;
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  display: flex;
  border-radius: 4px;
  font-size: 12px;
}

.search-clear:hover {
  background: #f1f5f9;
  color: #475569;
}
</style>
